import React from 'react';
import AppHeader from '../../../../components/Header/Header';
import AppFooter from '../../../../components/Footer/footer';
import BannerSection from '../../../../components/BannerSection';
import SidebarMenu from '../../../../components/SidebarMenu';
import SectionHeading from '../../../../components/SectionHeading';
import BreadcrumbNav from '../../../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Unidade Orgânica', href: '/programas/unidade-organica' },
    { label: 'Ciências Econômicas Juridicas e Humanas', },
    { label: 'Apresentação' }
];

function Index() {
    return (
        <>
            <header id='header'>
                <AppHeader />
            </header>
            <BannerSection
                title="Unidade Orgânica de Ciências Econômicas Juridicas e Humanas "
                subtitle="Bem-vindo à Unidade Orgânica de Ciências Econômicas Juridicas e Humanas"
                description={`Descubra um ambiente de aprendizado inovador, onde a excelência acadêmica e a prática se encontram para formar profissionais altamente qualificados.`}
                backgroundImage={require('../../../../assets/UN_OR_E_J.jpg')}
                backgroundId="instituition-Banner"
            />
             <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
                <br />
                <div className="row flex-row-reverse">
                     <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                        <SidebarMenu
                            title="Navegação"
                            items={[
                            { label: "Apresentação", href: "/programas/unidade-organica/ciencia-humanas" },
                            { label: "Missão Visão e Valores", href: "/programas/unidade-organica/ciencia-humanas/missao-visao-valores" },
                            ]}
                        />
                        </div>
                    <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                        <br />
                        <div style={{ marginLeft: '50px' }} className="details-magazine">

                            <p className="f-reg">
                                 <SectionHeading title="Breve Historial" />
                                <br />
                                A Unidade Orgânica de Ciências Económicas, Jurídicas e Humanas designada
                                doravante, abreviadamente (UOCEJH), é uma entidade do Instituto Superior Politécnico
                                Atlântida, um estabelecimento privado de ensino superior, integrado no subsistema do
                                ensino superior em Angola
                                <br /><br /> Em 2013 arrancou o ano académico com mais de 400 estudantes, 8 cursos, 40
                                docentes, 27 salas de aulas. Os cursos ministrados no ano 2013 foram s seguintes: Gestão
                                de Empresas, Gestão de Recursos Humanos, Gestão de Contabilidade, Psicologia,
                                Pedagogia, Economia, Relações Internacionais e Direito com cerca de 67. 
                                <br /><br /> Ao longo deste
                                periodo a unidade orgânica foi crescendo em termos de número de estudantes, tendo
                                atingido até o ano de 2019 mais de 2 mil estudantes, em 2020 devido ao aparecimento
                                da COVID-19 que assolou o mundo em geral, houve pouca aderência. Em 2018 foram
                                outorgados mais de 100 estudantes da primeira promoção, e em 2021 mais de 200
                                estudantes, quadros de alta qualificação, esperando que os mesmos façam a diferença no
                                mercado nacional e Internacional gerando e difundindo conhecimentos, preservando e
                                divulgando valores para a transformação das sociedades.

                                <br /><br /> 

                                Atualmente, a Unidade Orgânica de Ciências Económicas, Jurídicas e Humanas
                                (UOCEJH), possui 8 Cursos, dentre os quais: Gestão de Empresas, Gestão de Recursos
                                Humanos, Gestão de Contabilidade, Psicologia, Ensino Primário, Economia, Relações
                                Internacionais e Direito. 

                                 <br /><br /> 

                                No decorrer do período compreendido entre 2018 à 2022, atendendo as
                                vicissitudes enfrentadas na Unidade Orgânica de Ciências Económicas Jurídicas e Humanas
                                (UOCEJH), urgiu a necessidade de redobrarmos esforços, participando no lançamento da
                                1ª Revista Científica do Instituto, denominada a Revista olhar Científico em 29 de Julho de
                                2022. 
                            </p>
                            <br />
                            <p className="f-reg">
                            <SectionHeading title="Inserção Regional" />
                            A Unidade Orgânica de Ciências Económicas, Jurídicas e Humanas está nas
                            Instalações sede do Instituto Superior Politécnico Atlântida, localizada na Província
                            de Luanda, município do Talatona na estrada direita do Patriota-Benfica. 
                            <br /><br />

                            A Unidade Orgânica encontra-se também inserida no Polo Capalanga na zona de
                            Viana, com os Cursos de Gestão de Empresas, Gestão de Recursos Humanos, Gestão
                            de Contabilidade e Psicologia
                            </p>
                            <br />

                            <p className="f-reg">
                            <SectionHeading title="Responsabilidade Social" />
                             A UOCEJH integra no projecto da Instituição denominado Necessitados da acção
                            social que oferece mais de 20 bolsas de estudo comparticipadas e 10 não
                            comparticipadas aos estudantes, desde que os mesmos apresentem certificado de
                            pobreza;
                            <br /><br />
                            A UOCEJH Deve promover uma educação e conscientização sobre questões sociais
                            e ambientais, organizando palestras, workshops e eventos voltados para a
                            comunidade acadêmica e para a população em geral;
                            <br></br>
                            A UOCEJH estimula a participação dos estudantes e docentes em atividades de
                            voluntariado, oferecendo oportunidades para que possam dedicar seu tempo e
                            habilidades para ajudar comunidades e grupos em situação de vulnerabilidade.
                            </p>

                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />
                <br />
                <br />
            </main>
            <footer id="footer">
                <AppFooter />
            </footer>
        </>
    );
}

export default Index;

